"use strict";
// @ts-ignore
try {
    self['workbox:core:6.5.1'] && _();
}
catch (e) { }
